export function paginate<T>(data: readonly T[], page: number, pageSize: number) {
  const totalItems = data.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = (currentPage - 1) * pageSize;
  const items = data.slice(start, start + pageSize);

  return { items, totalItems, totalPages, currentPage };
}